"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _InputGroup = _interopRequireDefault(require("react-bootstrap/InputGroup"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _Button = _interopRequireDefault(require("./Buttons/Button"));
var _customHooks = require("./custom-hooks");
var _date = require("./date");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CalCustomInput = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    errorText,
    hasError,
    inputId,
    label,
    onBlur,
    onClick,
    onSelect,
    placeholderText,
    selectsRange,
    value
  } = _ref;
  const [inputValue, setInputValue] = (0, _react.useState)(value);
  const [inputCursor, setInputCursor] = (0, _react.useState)(value);
  const inputRef = (0, _react.useRef)();
  const handleBlur = (0, _react.useCallback)((0, _customHooks.useBlurryDateParse)(selectsRange, inputValue, onSelect, onBlur), [inputValue, onBlur, onSelect, selectsRange]);
  const handleChange = (0, _react.useCallback)(e => {
    const value = e.target.value;

    /* istanbul ignore else */
    if (inputRef.current) {
      setInputCursor(inputRef.current.selectionStart);
      if (inputRef.current.selectionStart === 3 && value.length === 3) {
        setInputCursor(4);
      } else if (inputRef.current.selectionStart === 6 && value.length === 6) {
        setInputCursor(7);
      } else if (inputRef.current.selectionStart === 10 && value.length === 10) {
        setInputCursor(13);
      } else if (inputRef.current.selectionStart === 11 && value.length === 11) {
        setInputCursor(14);
      } else if (inputRef.current.selectionStart === 16 && value.length === 16) {
        setInputCursor(17);
      } else if (inputRef.current.selectionStart === 19 && value.length === 19) {
        setInputCursor(20);
      }
    }

    // catch the case where a backspace is removing the hyphen between start
    // and end dates
    const backingUp = value.match(/.*\d{4} -$/);

    // strip all characters, besides digits
    const digits = value.replace(/\D/g, '');

    // empty? good!
    if (digits === '') {
      setInputValue(digits);
      return;
    }

    // just the year part? good!
    if (digits.match(/^\d{1,2}$/)) {
      setInputValue(digits);
      return;
    }

    // a month and day part of a year? good!
    const monthDay = digits.match(/^(\d{2})(\d{1,2})$/);
    if (monthDay) {
      setInputValue(`${monthDay[1]}/${monthDay[2]}`);
      return;
    }

    // a month and day, and most (up to 3 digits) of a year? good!
    const monthDayAlmostYear = digits.match(/^(\d{2})(\d{2})(\d{1,3})$/);
    if (monthDayAlmostYear) {
      setInputValue(`${monthDayAlmostYear[1]}/${monthDayAlmostYear[2]}/${monthDayAlmostYear[3]}`);
      return;
    }

    // a full date? good!
    const monthDayYear = digits.match(/^(\d{2})(\d{2})(\d{4})$/);
    if (monthDayYear) {
      // add the separator (" - ") if this is a range, and you're not backspacing
      const sep = selectsRange && !backingUp ? ' - ' : '';
      setInputValue(`${monthDayYear[1]}/${monthDayYear[2]}/${monthDayYear[3]}${sep}`);
      return;
    }

    // all done checking if this is a single date picker
    if (!selectsRange) {
      return;
    }

    // a full date + the beginning of a month? good!
    const twoMonths = digits.match(/^(\d{2})(\d{2})(\d{4})(\d{1,2})$/);
    if (twoMonths) {
      setInputValue(`${twoMonths[1]}/${twoMonths[2]}/${twoMonths[3]} - ${twoMonths[4]}`);
      return;
    }

    // a full date + a month and the beginning of a day? good!
    const twoDays = digits.match(/^(\d{2})(\d{2})(\d{4})(\d{2})(\d{1,2})$/);
    if (twoDays) {
      setInputValue(`${twoDays[1]}/${twoDays[2]}/${twoDays[3]} - ${twoDays[4]}/${twoDays[5]}`);
      return;
    }

    // two full dates? hooray!
    const complete = digits.match(/^(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})(\d{1,4}).*/);
    /* istanbul ignore else */
    if (complete) {
      setInputValue(`${complete[1]}/${complete[2]}/${complete[3]} - ${complete[4]}/${complete[5]}/${complete[6]}`);
      return;
    }
  }, [inputRef, selectsRange]);
  const inputGroupClassName = hasError ? 'is-invalid' : '';
  const renderError = (hasError, errorText) => {
    if (hasError === true) {
      return /*#__PURE__*/_react.default.createElement(_Form.default.Control.Feedback, {
        type: "invalid"
      }, errorText);
    }
  };
  (0, _react.useEffect)(() => {
    setInputValue(value);
  }, [value]);
  (0, _react.useLayoutEffect)(() => {
    /* istanbul ignore else */
    if (inputRef.current) {
      inputRef.current.setSelectionRange(inputCursor, inputCursor);
    }
  }, [inputRef, inputCursor, inputValue]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Form.default.Label, {
    htmlFor: inputId
  }, label), /*#__PURE__*/_react.default.createElement(_InputGroup.default, {
    className: inputGroupClassName
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Control, {
    htmlSize: selectsRange ? 52 : 21,
    id: inputId,
    onBlur: handleBlur,
    onChange: handleChange,
    placeholder: placeholderText,
    ref: inputRef,
    value: inputValue,
    type: "text",
    inputMode: "numeric"
  }), /*#__PURE__*/_react.default.createElement(_InputGroup.default.Append, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onClick,
    ref: ref,
    variant: "link"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Choose Date"), /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true",
    className: "icon-calendar",
    title: "ChooseDate"
  })))), renderError(hasError, errorText));
});
CalCustomInput.displayName = 'DatePicker.CustomInput';
CalCustomInput.propTypes = {
  errorText: _propTypes.default.string,
  hasError: _propTypes.default.bool,
  inputId: _propTypes.default.string,
  label: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  placeholderText: _propTypes.default.string,
  selectsRange: _propTypes.default.bool,
  value: _propTypes.default.any
};
const MultiMonthHeader = _ref2 => {
  let {
    customHeaderCount,
    decreaseMonth,
    increaseMonth,
    monthDate,
    nextMonthButtonDisabled,
    prevMonthButtonDisabled
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "react-datepicker__current-month--custom"
  }, /*#__PURE__*/_react.default.createElement("b", {
    className: "react-datepicker__current-month"
  }, (0, _date.getMonth)(monthDate), " ", (0, _date.getYear)(monthDate)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": "Previous Month",
    className: "react-datepicker__navigation-icon--previous--custom",
    disabled: prevMonthButtonDisabled,
    onClick: decreaseMonth,
    style: customHeaderCount === 0 ? {
      visibility: 'hidden'
    } : null,
    variant: "inline"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-caret-spin-left"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Previous Month")), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": "Next Month",
    className: "react-datepicker__navigation-icon--next--custom",
    disabled: nextMonthButtonDisabled,
    onClick: increaseMonth,
    style: customHeaderCount === 0 ? {
      visibility: 'hidden'
    } : null,
    variant: "inline"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-caret"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Next Month")));
};
MultiMonthHeader.displayName = 'DatePicker.MultiMonthHeader';
MultiMonthHeader.propTypes = {
  customHeaderCount: _propTypes.default.number.isRequired,
  decreaseMonth: _propTypes.default.func.isRequired,
  increaseMonth: _propTypes.default.func.isRequired,
  monthDate: _propTypes.default.any.isRequired,
  nextMonthButtonDisabled: _propTypes.default.bool.isRequired,
  prevMonthButtonDisabled: _propTypes.default.bool.isRequired
};
const SingleMonthHeader = _ref3 => {
  let {
    decreaseMonth,
    increaseMonth,
    monthDate,
    nextMonthButtonDisabled,
    prevMonthButtonDisabled
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "react-datepicker__current-month--custom"
  }, /*#__PURE__*/_react.default.createElement("b", {
    className: "react-datepicker__current-month"
  }, (0, _date.getMonth)(monthDate), " ", (0, _date.getYear)(monthDate)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": "Previous Month",
    className: "react-datepicker__navigation-icon--previous--custom",
    disabled: prevMonthButtonDisabled,
    onClick: decreaseMonth,
    variant: "inline"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-caret-spin-left"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Previous Month")), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": "Next Month",
    className: "react-datepicker__navigation-icon--next--custom",
    disabled: nextMonthButtonDisabled,
    onClick: increaseMonth,
    variant: "inline"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-caret"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Next Month")));
};
SingleMonthHeader.displayName = 'DatePicker.SingleMonthHeader';
SingleMonthHeader.propTypes = {
  decreaseMonth: _propTypes.default.func.isRequired,
  increaseMonth: _propTypes.default.func.isRequired,
  monthDate: _propTypes.default.any.isRequired,
  nextMonthButtonDisabled: _propTypes.default.bool.isRequired,
  prevMonthButtonDisabled: _propTypes.default.bool.isRequired
};
const selectCustomHeader = multi => {
  if (multi) {
    return MultiMonthHeader;
  } else {
    return SingleMonthHeader;
  }
};

/**
 * A DatePicker looks like an input group, but opens a floating calendar panel
 * to enable date selection.
 */
const MMDatePicker = _ref4 => {
  let {
    endDate,
    errorText,
    hasError,
    inputGroupClassName,
    id,
    label,
    placeholderText,
    selected,
    selectsRange,
    startDate,
    ...props
  } = _ref4;
  const [selectedDate, setSelectedDate] = (0, _react.useState)(selected);
  const [selectedStartDate, setSelectedStartDate] = (0, _react.useState)(startDate);
  const [selectedEndDate, setSelectedEndDate] = (0, _react.useState)(endDate);
  const handleSelect = /* istanbul ignore next */(changes, evt) => {
    // this selection handler is called when the textbox loses focus.
    // `changes` could be a null value, a date object, or a two-element array
    // of date objects
    if (changes === null) {
      setSelectedDate(null);
    } else if (Object.prototype.toString.call(changes) === '[object Date]') {
      setSelectedDate(changes);
    } else if (changes.length === 2) {
      setSelectedStartDate(changes[0]);
      setSelectedEndDate(changes[1]);
    }

    // now that the dates have been set, emit an onChange event to the consumer
    props.onChange(changes, evt);
  };
  (0, _react.useEffect)(() => {
    setSelectedDate(selected);
  }, [selected]);
  (0, _react.useEffect)(() => {
    setSelectedStartDate(startDate);
  }, [startDate]);
  (0, _react.useEffect)(() => {
    setSelectedEndDate(endDate);
  }, [endDate]);

  // memo-ize the Input Group, which is used as the `customInput` prop of the picker
  const customInput = (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(CalCustomInput, {
    errorText: errorText,
    hasError: hasError,
    inputGroupClassName: inputGroupClassName,
    inputId: id,
    label: label,
    onSelect: handleSelect,
    placeholderText: placeholderText,
    selectsRange: selectsRange
  }), [errorText, hasError, id, label, placeholderText, selectsRange]);
  return /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({
    customInput: customInput,
    popperModifiers: [{
      name: 'offset',
      options: {
        offset: [0, 2]
      }
    }],
    renderCustomHeader: selectCustomHeader(selectsRange),
    showPopperArrow: false,
    monthsShown: selectsRange ? 2 : 1,
    preventOpenOnFocus: true,
    selected: selectedDate,
    selectsRange: selectsRange,
    startDate: selectedStartDate,
    endDate: selectedEndDate
  }, props));
};
var _default = exports.default = MMDatePicker;
MMDatePicker.propTypes = {
  /**
   * The end of the date range; only used when "selectsRange" is `true`.
   */
  endDate: _propTypes.default.any,
  /**
   * The DOM ID of the HTML Input element.
   */
  id: _propTypes.default.string,
  /**
   * Additional classes to put on the input group.
   */
  inputGroupClassName: _propTypes.default.string,
  /**
   * The text label for this HTML Input element.
   */
  label: _propTypes.default.string.isRequired,
  /**
   * A close event, invoked when the DatePicker calendar pop-up is closed.
   */
  onCalendarClose: _propTypes.default.func,
  /**
   * An open event, invoked when the DatePicker calendar pop-up is opened.
   */
  onCalendarOpen: _propTypes.default.func,
  /**
   * A change event, invoked when a date is selected.
   */
  onChange: _propTypes.default.func.isRequired,
  /**
   * The placeholder text for the input group.
   */
  placeholderText: _propTypes.default.string,
  /**
   * The selected date; use when "selectsRange" is `false`.
   */
  selected: _propTypes.default.any,
  /**
   * A flag indicating if a single date, or a range of dates should be selectable.
   */
  selectsRange: _propTypes.default.bool,
  /**
   * The start of the date range; only used when "selectsRange" is `true`.
   */
  startDate: _propTypes.default.any,
  /**
   * Sets error state of datepicker input.
   */
  hasError: _propTypes.default.bool,
  /**
   * The error message below field; only shown when "hasError" is `true`.
   */
  errorText: _propTypes.default.string
};
MMDatePicker.defaultProps = {
  endDate: null,
  label: 'Date:',
  selected: null,
  selectsRange: false,
  startDate: null,
  hasError: false,
  errorText: 'Please select a date'
};